import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightInactive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 26,
	viewBox: "0 0 14 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.84616 3.8506e-05C4.98393 3.8506e-05 5.12179 0.074716 5.22688 0.224074L13.8422 12.4594C14.0526 12.7579 14.0526 13.2421 13.8422 13.5407L5.22688 25.776C5.12181 25.9253 4.98394 26 4.84616 26H0.538471C0.4007 26 0.262833 25.9253 0.157752 25.776C-0.0525841 25.4774 -0.0525841 24.9932 0.157752 24.6946L8.39351 12.9981L0.157752 1.30537C-0.0525841 1.0068 -0.0525841 0.522577 0.157752 0.224036C0.262814 0.0746813 0.400689 0 0.538471 0L4.84616 3.8506e-05Z",
		fill: "#DCDCDC"
	})
});
export default SvgRightInactive;
